import React, { useState, useContext, useEffect, useRef } from 'react';
import NewsLetterArea from "./NewsLetterArea";
import { SessionContext } from "../../common/SessionContext";

function Subscribe(props) {

  const { session } = useContext(SessionContext);
  const tracked_id = session.ws;

  const { ctype } = props.match.params;
  const { item_id } = props.match.params;

  return (
    <>
      <NewsLetterArea ctype={ctype} item_id={item_id} tracked_id={tracked_id} />
    </>
  );
}

export default Subscribe;
